import { QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { queryClient } from "./api/queryClient";
import { App } from "./app/App";
import "./styles/global.css";
import "./styles/advertising.css";
import "./styles/rewards.css";
import "./styles/venues.css";
import "./styles/stats.css";
import "./styles/messages.css";
import "./styles/storeSetup.css";
import "./styles/offerSetup.css";
import "./styles/admin.css";
import "./styles/twoStep.css";

/*
 * No <StrictMode>: in development it mounts effects twice, which would create the Babylon engine
 * twice and join/leave the realtime room twice per load (burning a single-use room ticket and
 * bumping the control version). The town layout's effects are still cleanup-correct.
 */
createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>,
);
